export default "/undelivered.8aa6359b-040433.svg?svgr";